import { render } from "./SonstigeInformationen.vue?vue&type=template&id=1f92cf27"
import script from "./SonstigeInformationen.vue?vue&type=script&lang=js"
export * from "./SonstigeInformationen.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__